import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import PercentageFigure from '../../PercentageFigure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'f',
  title: 'Price Change Percent (30 Day)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '30d';
  }

  get overlayText() {
    return 'Price Change % in last 30 days';
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <PercentageFigure amount={props.row.priceChange30d} />
    </td>
  );
}


class PriceChange30d extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get visible() {
    return false;
  }

  sortAscending(a, b) {
    if (a.priceChange30d < b.priceChange30d) {
      return -1;
    }
    if (a.priceChange30d > b.priceChange30d) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange30d < b.priceChange30d) {
      return 1;
    }
    if (a.priceChange30d > b.priceChange30d) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PriceChange30d;

